import { render, staticRenderFns } from "./IntentStat.vue?vue&type=template&id=52ac2072&scoped=true&"
import script from "./IntentStat.vue?vue&type=script&lang=js&"
export * from "./IntentStat.vue?vue&type=script&lang=js&"
import style0 from "./IntentStat.vue?vue&type=style&index=0&id=52ac2072&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac2072",
  null
  
)

export default component.exports